import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportUploadFilePayload } from '../types';
import {
  REPORT_INNER_TAB_QUERY,
  REPORT_UPLOAD_FILE_API_URL,
  REPORT_UPLOAD_FILE_MUTATION,
} from '../constants';

export default function useReportUploadFileMutation(): IContextMutationResult<void, Error, IReportUploadFilePayload> {
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, IReportUploadFilePayload>({
    mutationKey: [REPORT_UPLOAD_FILE_MUTATION],
    mutationFn: ({
      options: {
        reportType,
        widgetType,
        permission,
      },
      tabId,
      innerTabId,
      formData,
    }) => fetchPut<void>(
      REPORT_UPLOAD_FILE_API_URL,
      formData,
      {
        permission,
        urlParams: {
          reportType,
          widgetType,
          tabId,
          innerTabId,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [REPORT_INNER_TAB_QUERY] });
    },
  });
}
